import React from 'react';
import { Button } from './ui/button';
import { ArrowRight } from 'lucide-react';

const Hero = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="hero" className="relative pt-32 pb-20 lg:pt-40 lg:pb-32 overflow-hidden">
      <div className="absolute inset-0 -z-10">
        <div className="absolute top-20 right-0 w-96 h-96 bg-slate-100 rounded-full blur-3xl opacity-50 animate-float-slow"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-blue-50 rounded-full blur-3xl opacity-40 animate-float-delayed"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-end">
          <div className="animate-fade-in-up">
            <h1 className="text-3xl lg:text-4xl xl:text-5xl font-bold text-slate-900 mb-6 leading-tight">
              Portokosten senken. Prozesse stärken.
              <span className="block mt-4 text-xl lg:text-2xl xl:text-3xl whitespace-nowrap" style={{ color: '#FFA266' }}>Transparent beraten. Direkt umsetzen.</span>
            </h1>
            
            <p className="text-xl text-slate-600 mb-10 max-w-2xl leading-relaxed">
              Als Berater und Umsetzungspartner durchleuchte ich Ihre Versandprozesse, senke Ihre Portokosten nachweislich — und begleite die Umstellung persönlich bis zum stabilen Regelbetrieb.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                onClick={() => scrollToSection('kontakt')}
                className="text-slate-900 px-8 py-6 text-lg h-auto group hover:shadow-xl transition-all duration-300 hover:scale-105 font-semibold"
                style={{ backgroundColor: '#FFA266' }}
                data-testid="hero-cta-btn"
              >
                Kostenlose Erstanalyse anfordern
                <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
              </Button>
              <Button
                onClick={() => scrollToSection('leistungen')}
                variant="outline"
                className="border-slate-300 text-slate-700 hover:bg-slate-50 px-8 py-6 text-lg h-auto hover:border-slate-400 transition-all duration-300"
              >
                Mehr erfahren
              </Button>
            </div>
          </div>

          <div className="hidden lg:flex flex-col items-center animate-fade-in-up">
            <div className="w-72 h-72 xl:w-80 xl:h-80 rounded-full overflow-hidden shadow-2xl mb-6" style={{ border: '5px solid #FFA266' }}>
              <img src="/team-bernd.png" alt="Bernd Deninger - Senior Consultant" className="w-full h-full object-cover" />
            </div>
            <div className="bg-white/90 backdrop-blur-sm rounded-lg shadow-lg px-6 py-3 border border-slate-200">
              <p className="font-semibold text-slate-900 text-center">Bernd Deninger</p>
              <p className="text-sm text-slate-500 text-center">Senior Consultant</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
